import { TopicResult } from "common/topic/dto/TopicResult";
import styled from "styled-components";
import CharUpdateFromText from "./CharUpdateFromText";
import TextCharEdit from "./TextCharEdit";

type TopicTextCharsProps = {
  topic: TopicResult;
};

const TopicTextChars = ({ topic }: TopicTextCharsProps) => {
  return (
    <Div>
      <CharUpdateFromText topicId={topic.id} />
      <DivCharacters>
        <TextCharEdit topic={topic} />
      </DivCharacters>
    </Div>
  );
};

const Div = styled.div`
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
`;

const DivCharacters = styled.div`
  margin-top: 2rem;
`;

export default TopicTextChars;
